import type { LanguageValue } from '@elfsight/configurator-contracts';

/**
 * Formats a number into a compact, abbreviated string representation.
 *
 * @param {number} value - The number to be formatted.
 * @param {LanguageValue} [language] - The `language` property of `LanguageValue` is used for locale. If it is not provided, it defaults to browser locale.
 * @returns {string} The formatted, abbreviated number as a string.
 */

export function formatAbbrNumber(
  value: number,
  language?: LanguageValue
): string {
  const formatter = new Intl.NumberFormat(language?.language, {
    notation: 'compact',
    maximumFractionDigits: 1
  });

  return formatter.format(value);
}
